module.exports = __webpack_public_path__ + "statics/img/regeist.5b57e6e1.jpg";